!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["@hotmart/cosmos"] = t() : e["@hotmart/cosmos"] = t();
}(self, function () {
  return function () {
    "use strict";

    var e = {
      7705: function _(e) {
        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var o = "",
                  n = void 0 !== t[5];
              return t[4] && (o += "@supports (".concat(t[4], ") {")), t[2] && (o += "@media ".concat(t[2], " {")), n && (o += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), o += e(t), n && (o += "}"), t[2] && (o += "}"), t[4] && (o += "}"), o;
            }).join("");
          }, t.i = function (e, o, n, i, r) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var a = {};
            if (n) for (var s = 0; s < this.length; s++) {
              var l = this[s][0];
              null != l && (a[l] = !0);
            }

            for (var c = 0; c < e.length; c++) {
              var u = [].concat(e[c]);
              n && a[u[0]] || (void 0 !== r && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = r), o && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = o) : u[2] = o), i && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = i) : u[4] = "".concat(i)), t.push(u));
            }
          }, t;
        };
      },
      6738: function _(e) {
        e.exports = function (e) {
          return e[1];
        };
      },
      5097: function _(e, t, o) {
        o.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = o(6738),
            i = o.n(n),
            r = o(7705),
            a = o.n(r)()(i());
        a.push([e.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
        var s = a;
      },
      5268: function _(e, t, o) {
        o.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = o(6738),
            i = o.n(n),
            r = o(7705),
            a = o.n(r)()(i());
        a.push([e.id, ':host{color:var(--gray-700, #32363b);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol");overflow:hidden;padding:0;position:relative;white-space:nowrap;width:100%}:host .hot-application-menu__item{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:transparent;border:0;-webkit-border-radius:var(--border-radius, 0.25rem);-moz-border-radius:var(--border-radius, 0.25rem);border-radius:var(--border-radius, 0.25rem);color:var(--gray-700, #32363b);display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;overflow:hidden;padding:var(--structure-menu-item-padding, 0.75rem 1rem);-webkit-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),width var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-o-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),width var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));-moz-transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),width var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));transition:background-color var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1)),width var(--timing, 500ms) var(--easing, cubic-bezier(0.2, 1, 0.2, 1));width:100%}@media screen and (prefers-reduced-motion: reduce){:host .hot-application-menu__item{-webkit-transition:none;-o-transition:none;-moz-transition:none;transition:none}}:host .hot-application-menu__item::before{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--gray-200, #e6e9ed);border-color:var(--gray-200, #e6e9ed);-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;border-style:solid;border-width:var(--component-border-width, 0.0625rem);content:"";display:var(--structure-menu-item-bullet-display, block);-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;height:var(--spacer-2, 0.5rem);-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;left:23px;opacity:0;position:absolute;width:var(--spacer-2, 0.5rem)}:host .hot-application-menu__item::after{background-color:var(--gray-200, #e6e9ed);bottom:0;content:"";display:none;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;height:100%;left:27px;opacity:0;position:absolute;width:var(--component-border-width, 0.0625rem)}:host .hot-application-menu__item:hover{background-color:var(--gray-100, #f7f9fa)}:host hot-collapse{--collapse-padding: 0;-webkit-border-radius:var(--border-radius, 0.25rem);-moz-border-radius:var(--border-radius, 0.25rem);border-radius:var(--border-radius, 0.25rem);margin:0;overflow:hidden;position:relative;width:100%}:host ::slotted(.hot-application-menu__icon){-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0;font-size:var(--text-4, 1.5rem);height:var(--spacer-5, 1.5rem);-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;left:0;position:relative;width:var(--spacer-5, 1.5rem)}:host ::slotted(.hot-application-menu__icon:empty){background-color:var(--gray-200, #e6e9ed)}:host ::slotted(span){margin-left:var(--structure-menu-item-label-margin, 1.5rem)}:host(.hot-application-menu__item--active),:host([active]){z-index:2}:host(.hot-application-menu__item--active) .hot-application-menu__item,:host([active]) .hot-application-menu__item{background-color:var(--structure-menu-item-bg, #fdece7);color:var(--structure-menu-item-color, #c5310a)}:host(.hot-application-menu__item--active) .hot-application-menu__item::before,:host([active]) .hot-application-menu__item::before{background-color:var(--structure-menu-item-color, #c5310a)}:host([slot=collapsed]) .hot-application-menu__item{padding-left:var(--spacer-7, 2.5rem)}:host([slot=collapsed]) .hot-application-menu__item::before,:host([slot=collapsed]) .hot-application-menu__item::after{opacity:1}', ""]);
        var s = a;
      }
    },
        t = {};

    function o(n) {
      var i = t[n];
      if (void 0 !== i) return i.exports;
      var r = t[n] = {
        id: n,
        exports: {}
      };
      return e[n](r, r.exports, o), r.exports;
    }

    o.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return o.d(t, {
        a: t
      }), t;
    }, o.d = function (e, t) {
      for (var n in t) {
        o.o(t, n) && !o.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, o.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var n = {};
    return function () {
      o.r(n);

      var e = require("@babel/runtime/helpers/classCallCheck");

      var t = o.n(e);

      var i = require("@babel/runtime/helpers/createClass");

      var r = o.n(i);

      var a = require("@babel/runtime/helpers/assertThisInitialized");

      var s = o.n(a);

      var l = require("@babel/runtime/helpers/get");

      var c = o.n(l);

      var u = require("@babel/runtime/helpers/inherits");

      var d = o.n(u);

      var p = require("@babel/runtime/helpers/possibleConstructorReturn");

      var m = o.n(p);

      var h = require("@babel/runtime/helpers/getPrototypeOf");

      var b = o.n(h);

      var v = require("@babel/runtime/helpers/wrapNativeSuper");

      var f = o.n(v),
          g = o(5097);

      var y = function (e) {
        d()(a, e);
        var o,
            n,
            i = (o = a, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = b()(o);

          if (n) {
            var i = b()(this).constructor;
            e = Reflect.construct(t, arguments, i);
          } else e = t.apply(this, arguments);

          return m()(this, e);
        });

        function a(e) {
          var o;
          t()(this, a);
          var n = (o = i.call(this)).getTemplate(),
              r = document.createElement("template");
          r.innerHTML = n;
          var s = r.content.querySelector("style");
          return s && (s.innerHTML = "".concat(s.innerHTML, " ").concat(g.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(r, e), o.attachShadow({
            mode: "open"
          }), o.shadowRoot.appendChild(document.importNode(r.content, !0)), o;
        }

        return r()(a, [{
          key: "connectedCallback",
          value: function value() {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function value() {
            return "";
          }
        }]), a;
      }(f()(HTMLElement));

      var _ = y;
      var w = "openmenu",
          k = "closemenu",
          x = "openmenuitem",
          S = "closemenuitem",
          C = "open",
          z = o(5268);
      var M,
          O,
          E = "hot-menu-item";
      M = E, O = function (e) {
        d()(a, e);
        var o,
            n,
            i = (o = a, n = function () {
          if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
          if (Reflect.construct.sham) return !1;
          if ("function" == typeof Proxy) return !0;

          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
          } catch (e) {
            return !1;
          }
        }(), function () {
          var e,
              t = b()(o);

          if (n) {
            var i = b()(this).constructor;
            e = Reflect.construct(t, arguments, i);
          } else e = t.apply(this, arguments);

          return m()(this, e);
        });

        function a() {
          var e;
          return t()(this, a), (e = i.call(this, E))._collapsedSlot = e.shadowRoot.querySelector('slot[name="collapsed"]'), e._collapse = e.shadowRoot.querySelector("hot-collapse"), e._onOpenCollapse = e._onOpenCollapse.bind(s()(e)), e._toggleCollapse = e._toggleCollapse.bind(s()(e)), e._onCloseMenu = e._onCloseMenu.bind(s()(e)), e._onOpenMenu = e._onOpenMenu.bind(s()(e)), e._onOpenMenuItem = e._onOpenMenuItem.bind(s()(e)), e._onCloseMenuItem = e._onCloseMenuItem.bind(s()(e)), e;
        }

        return r()(a, [{
          key: "connectedCallback",
          value: function value() {
            c()(b()(a.prototype), "connectedCallback", this).call(this), this._collapse.addEventListener("click", this._onOpenCollapse), this._collapsedSlot.addEventListener("slotchange", this._toggleCollapse), window.addEventListener(w, this._onOpenMenu), window.addEventListener(k, this._onCloseMenu), window.addEventListener(x, this._onOpenMenuItem), window.addEventListener(S, this._onCloseMenuItem), this._getStructureState();
          }
        }, {
          key: "disconnectedCallback",
          value: function value() {
            this._collapse.removeEventListener("click", this._onOpenCollapse), this._collapsedSlot.removeEventListener("slotchange", this._toggleCollapse), window.removeEventListener(w, this._onOpenMenu), window.removeEventListener(k, this._onCloseMenu), window.removeEventListener(x, this._onOpenMenuItem), window.removeEventListener(S, this._onCloseMenuItem);
          }
        }, {
          key: "attributeChangedCallback",
          value: function value(e) {
            e === C && this._onChangeOpen();
          }
        }, {
          key: "_onChangeOpen",
          value: function value() {
            this.hasAttribute(C) ? this._collapse.setAttribute("active", "") : this._collapse.removeAttribute("active");
          }
        }, {
          key: "_getStructureState",
          value: function value() {
            var e = document.querySelector("hot-structure");
            e && (e.getState().menuOpened ? this._onOpenMenu() : this._onCloseMenu());
          }
        }, {
          key: "_onOpenMenu",
          value: function value() {
            this.classList.remove("hot-application--minimized");
          }
        }, {
          key: "_onOpenMenuItem",
          value: function value(e) {
            var t = this.getAttribute("id");
            t && t === e.detail.id && (this.setAttribute(C, ""), window.dispatchEvent(new CustomEvent(w)));
          }
        }, {
          key: "_onCloseMenu",
          value: function value() {
            this.classList.add("hot-application--minimized");
          }
        }, {
          key: "_onCloseMenuItem",
          value: function value(e) {
            var t = this.getAttribute("id");
            t && t === e.detail.id && this.removeAttribute(C);
          }
        }, {
          key: "_onOpenCollapse",
          value: function value() {
            this._collapsedSlot.assignedNodes().length;
          }
        }, {
          key: "_toggleCollapse",
          value: function value() {
            this._collapsedSlot.assignedNodes().length ? this._collapse.removeAttribute("disabled") : this._collapse.setAttribute("disabled", "");
          }
        }, {
          key: "getTemplate",
          value: function value() {
            return "\n      <style>".concat(z.Z.toString(), '</style>\n      <hot-collapse disabled>\n        <div class="hot-application-menu__item">\n          <slot></slot>\n        </div>\n        <slot slot="collapsed" name="collapsed"></slot>\n      </hot-collapse>\n    ');
          }
        }], [{
          key: "observedAttributes",
          get: function get() {
            return [C];
          }
        }]), a;
      }(_), customElements.get(M) || customElements.define(M, O);
    }(), n;
  }();
});